export function mapTermBucket({ count, keycode }) {
  return {
    count,
    key: keycode
  }
}

export function mapKeyValueBucket({ keycode: id, label, count }) {
  return {
    count,
    key: {
      id,
      label
    }
  }
}

export function extractBuckets(mapper) {
  return function bucketMapper(data) {
    return data.filters.map(mapper)
  }
}

export const extractTermBuckets = extractBuckets(mapTermBucket)
export const extractKeyValueBuckets = extractBuckets(mapKeyValueBucket)
